import {
  ENDORSEMENT_CATEGORY,
  ENDORSEMENT_DECISION,
  ENDORSEMENT_STATUS,
  INSURANCE_TYPE,
  PRODUCT_CATEGORY,
} from '@shared/constants';
import { IEndorsementsResponse } from '@shared/interfaces';

export function mapDecisionToStatus(
  decision: ENDORSEMENT_DECISION
): ENDORSEMENT_STATUS {
  switch (decision) {
    case ENDORSEMENT_DECISION.RESOLVED:
      return ENDORSEMENT_STATUS.RESOLVED;
    case ENDORSEMENT_DECISION.REJECTED:
      return ENDORSEMENT_STATUS.REJECTED;
    case ENDORSEMENT_DECISION.CANCELED:
      return ENDORSEMENT_STATUS.CANCELED;
    default:
      throw new Error('Invalid status');
  }
}

export const ACTIONS = {
  RESPONSE: 'RESPONSE',
  CANCEL: 'CANCEL',
  ATTACHMENTS: 'ATTACHMENTS',
  ADDITIONAL_DOCUMENTS: 'ADDITIONAL_DOCUMENTS',
  INVOICE: 'INVOICE',
  REREQUEST: 'RE-REQUEST',
  DOWNLOAD: 'DOWNLOAD',
  SHARE_FEEDBACK: 'SHARE_FEEDBACK',
  SHARE_INVOICE: 'SHARE_INVOICE',
  VIEW_INVOICE: 'VIEW_INVOICE',
  RE_UPLOAD_INVOICE: 'RE-UPLOAD_INVOICE',
  EDIT_INVOICE_REQUEST: 'EDIT_INVOICE_REQUEST',
  ACCEPT_INVOICE: 'ACCEPT_INVOICE',
  SUBMIT_INVOICE: 'SUBMIT_INVOICE',
  RETURN_TO_INVOICE: 'RETURN_TO_INVOICE',
};

export function getCategory(category: PRODUCT_CATEGORY) {
  switch (category) {
    case PRODUCT_CATEGORY.GROUP:
      return 'Group';

    case PRODUCT_CATEGORY.INDIVIDUAL:
      return 'Individual';

    default:
      return '-';
  }
}

export function getType(type: INSURANCE_TYPE) {
  switch (type) {
    case INSURANCE_TYPE.LIFE:
      return 'Life';

    case INSURANCE_TYPE.GENERAL:
      return 'General';

    default:
      return '-';
  }
}

export const mockContacts = [
  // temp mock data
  {
    name: {
      salutation: 'Mr.',
      first_name: 'Aaqil',
      middle_name: '',
      last_name: 'Ruzzan',
      _id: '6768ea31894cdc45aed7a399',
    },
    contact_number: [
      {
        is_primary: true,
        type: 'Mobile',
        phone_number: {
          number: '123 456 789',
          internationalNumber: '+94 123 456 789',
          countryCode: 'LK',
          nationalNumber: '0123 456 789',
          e164Number: '+94123456789',
          dialCode: '+94',
          _id: '6768ea31894cdc45aed7a39b',
        },
        _id: '6768ea31894cdc45aed7a39a',
      },
    ],
    email: [
      {
        is_primary: true,
        type: 'Personal',
        email: 'ahamed.20220429@iit.ac.lk',
        _id: '6768ea31894cdc45aed7a39c',
      },
    ],
    designation: 'Manager',
    branch: 'Branch 3',
    is_primary: true,
    listed_products: [],
    _id: '6768ea6c894cdc45aed7a4dd',
  },
  {
    name: {
      salutation: 'Mrs.',
      first_name: 'Ahamed',
      middle_name: '',
      last_name: 'Aaqil',
      _id: '6768ea6c894cdc45aed7a4e3',
    },
    contact_number: [
      {
        is_primary: true,
        type: 'Mobile',
        phone_number: {
          number: '123 456 789',
          internationalNumber: '+94 123 456 789',
          countryCode: 'LK',
          nationalNumber: '0123 456 789',
          e164Number: '+94123456789',
          dialCode: '+94',
          _id: '6768ea6c894cdc45aed7a4e5',
        },
        _id: '6768ea6c894cdc45aed7a4e4',
      },
    ],
    email: [
      {
        is_primary: true,
        type: 'Personal',
        email: 'aaqilahamed880@gmail.com',
        _id: '6768ea6c894cdc45aed7a4e6',
      },
    ],
    designation: 'Manager',
    branch: 'Branch 1',
    is_primary: false,
    listed_products: ['6768ea31894cdc45aed7a399'],
    is_liaison_agent: true, // has to be dynamic in implementation
    _id: '6768ea6c894cdc45aed7a4e2',
  },
];

export function getEndorsementsTypeValue(
  endorsement: IEndorsementsResponse,
  financialTypes: { key: string; value: string }[],
  nonFinancialTypes: { key: string; value: string }[]
): string {
  let endorsementValue;
  if (endorsement.category === ENDORSEMENT_CATEGORY.FINANCIAL) {
    endorsementValue =
      financialTypes.find((type) => type.key === endorsement?.endorsementType)
        ?.value || '-';
  } else {
    endorsementValue =
      nonFinancialTypes.find(
        (type) => type.key === endorsement?.endorsementType
      )?.value || '-';
  }
  return endorsementValue;
}

export function getEndorsementCategoryValueForEmails(type: string) {
  switch (type) {
    case ENDORSEMENT_CATEGORY.FINANCIAL:
      return 'Financial';
    case ENDORSEMENT_CATEGORY.NON_FINANCIAL:
      return 'Non Financial';

    default:
      return '-';
  }
}
